import { t } from 'ttag'
import PropTypes from 'prop-types'
import { useContext } from 'react'

import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import explorerSvg from '@h2/assets/svg/illustrations/explore.svg'
import navianceLinkedAccountSvg from '@h2/assets/svg/illustrations/navianceLinkedAccount.svg'
import { Globals } from '@h2/globals'

import { Wrap } from './components'

const explorers = {
  student: t`Student`,
  jobseeker: t`Jobseeker`
}
const Explorer = ({ type }) => {
  const { isNavianceUser } = useContext(Globals)

  return (
    <Wrap>
      <Heading level="2" color="white" id="modal-title">
        <span>
          {isNavianceUser
            ? t`Create an account to link to Naviance!`
            : t`Create an account`}
        </span>
        <span>
          {isNavianceUser
            ? t`Create an account to link to Naviance!`
            : t`You are creating a ${explorers[type]} Explorer account`}
        </span>
      </Heading>
      <Text color="white">
        {isNavianceUser
          ? t`Link your Naviance and Headed2 accounts to access Headed2 features in Naviance.`
          : t`Complete the options on the right-hand side to help us optimize your account and start your career exploration.`}
      </Text>
      <img
        src={isNavianceUser ? navianceLinkedAccountSvg : explorerSvg}
        width="100%"
        height="auto"
        alt=""
      />
    </Wrap>
  )
}

Explorer.propTypes = {
  type: PropTypes.oneOf(Object.keys(explorers))
}

export { Explorer, explorers }
